
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion-united-media",
      function () {
        return require("private-next-pages/fashion-united-media.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashion-united-media"])
      });
    }
  